import { PERMIT2_ADDRESS } from '@uniswap/permit2-sdk'
import { configSwap } from './configs'

export function buildPermit(sellTokenAddress: string, sellAmount: string) {
  const deadline = Math.floor((Date.now() + 30 * 60 * 1000) / 1000).toString()
  const nonce = Date.now().toString()

  const domain = {
    name: 'Permit2',
    chainId: 480,
    verifyingContract: PERMIT2_ADDRESS,
  }

  const types = {
    TokenPermissions: [
      {
        name: 'token',
        type: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
      },
    ],
    PermitTransferFrom: [
      {
        name: 'permitted',
        type: 'TokenPermissions',
      },
      {
        name: 'spender',
        type: 'address',
      },
      {
        name: 'nonce',
        type: 'uint256',
      },
      {
        name: 'deadline',
        type: 'uint256',
      },
    ],
  }

  const permit = {
    permitted: {
      token: sellTokenAddress,
      amount: sellAmount,
    },
    spender: configSwap.CONTRACT,
    nonce,
    deadline,
  }

  return {
    domain,
    types,
    primaryType: 'PermitTransferFrom',
    message: permit,
  }
}

// export function buildPermit(sellTokenAddress: any, sellAmount: any) {
//   const deadline = Math.floor((Date.now() + 30 * 60 * 1000) / 1000).toString()
//   const nonce = Date.now().toString()

//   const permit2Address = '0x000000000022D473030F116dDEE9F6B43aC78BA3'
//   const domain = {
//     name: 'Permit2',
//     chainId: 480,
//     verifyingContract: permit2Address,
//   }

//   const types = {
//     TokenPermissions: [
//       { name: 'token', type: 'address' },
//       { name: 'amount', type: 'uint256' },
//     ],
//     PermitTransferFrom: [
//       {
//         name: 'permitted',
//         type: 'TokenPermissions',
//       },
//       { name: 'nonce', type: 'uint256' },
//       { name: 'deadline', type: 'uint256' },
//     ],
//   }

//   const permit = {
//     permitted: {
//       token: sellTokenAddress,
//       amount: sellAmount,
//     },
//     nonce,
//     deadline,
//   }

//   return {
//     domain,
//     types,
//     primaryType: 'PermitTransferFrom',
//     message: permit,
//   }
// }
